import React, { useCallback } from 'react'
import { IconButton, Icon } from '@material-ui/core'

const CalendarIconButton = ({ onClicked }) => {
	const handleOnClick = useCallback(() => {
		if (onClicked) {
			onClicked()
		}
	}, [onClicked])

	return (
		<IconButton onClick={handleOnClick}>
			<Icon
				className="far fa-calendar-alt"
				style={{
					fontSize: '1.325rem'
				}}
			/>
		</IconButton>
	)
}

export default CalendarIconButton
